<template>
  <div class="event-list-wrapper" v-if="epgEventListExists">
    <div class="loader" :class="{'show-loader': changing}">
      <p class="loader-fallback">
        {{ $t('login_loading') + '...' }}
      </p>
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
      </svg>
    </div>
    <div class="inner-wrapper" :class="{'changing': changing}">
      <div id="events-scroll" class="optiscroll">
        <div class="optiscroll-content">
          <ul class="event-list" :class="{'list-view': isListView}">
            <event v-for="(item, index) in epgWithDays" :key="index" :item="item"
                   :partsOfDay="partsOfDay"
                   :reloadMarker="reloadMarker"
                   :showEvents="showEvents"
            />
          </ul>
        </div>
        <div class="marker marker-top" @click="centerLiveEvent"></div>
        <div class="marker marker-bottom" @click="centerLiveEvent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Event from './Event'
import Optiscroll from 'optiscroll'
import DateTimeHelper from 'helpers/date'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'EventList',
  components: {
    Event,
    Optiscroll
  },
  data: function () {
    return {
      currentEventIndex: 0,
      epgWithDays: [],
      difference: 100,
      totalDaysInEPG: 11,
      changing: true,
      calendarDayOnScroll: '',
      markerPosition: ''
    }
  },
  props: {
    isListView: Boolean,
    partsOfDay: Object
  },
  computed: {
    ...mapState({
      epgItems: state => state.guide.epgForList,
      selectedChannel: state => state.guide.channelForEpg,
      calendarScrollToSelector: state => state.guide.calendarScrollToSelector
    }),
    epgEventListExists: function () {
      return this.epgItems.length > 0
    },
    epgEventListLength: function () {
      return this.epgWithDays.length
    },
    channelChanged: function () {
      return this.selectedChannel.id && this.epgItems.length
    }
  },
  methods: {
    ...mapMutations([
      'UPDATE_CALENDAR_DAY',
      'UPDATE_IS_LOADING'
    ]),
    createEpgWithDays: function () {
      let epg = this.epgItems
      let epgLength = epg.length
      let currentDay = 7
      let arr = []

      for (let i = 0; i < epgLength; i++) {
        let dayFormat = DateTimeHelper.format(epg[i].startTime, 'YYYY-MM-DD') // Format day for IE
        let day = new Date(dayFormat).getDay()

        if (day !== currentDay) {
          epg[i].firstInDay = true
          currentDay = day
          let dayItem = {
            time: epg[i].startTime
          }
          arr.push(dayItem)
        } else {
          epg[i].firstInDay = false
        }
        arr.push(epg[i])
      }
      this.epgWithDays = arr
    },
    initOptiscroll: function () {
      this.scrollAreaDOM = this.$el.querySelector('#events-scroll')
      this.optiscrollInstance = new Optiscroll(this.scrollAreaDOM, {
        wrapContent: false
      })
    },
    initCenterLiveEvent: function () {
      this.liveEventDOM = this.$el.querySelector('.live-event')
      this.scrollPos = (this.scrollAreaDOM.clientHeight - this.liveEventDOM.clientHeight) / 2
      this.centerLiveEvent()
    },
    centerLiveEvent: function () {
      this.optiscrollInstance.scrollIntoView('.live-event', 0, {
        top: this.scrollPos,
        bottom: this.scrollPos
      })
      if (this.liveMarkerTop) {
        this.liveMarkerTop.classList.remove('hidden')
      }
      if (this.liveMarkerBottom) {
        this.liveMarkerBottom.classList.remove('hidden')
      }
    },
    centerCustomEvent: function (selector) {
      this.optiscrollInstance.scrollIntoView(selector, 1000, {
        top: this.scrollPos,
        bottom: this.scrollPos
      })
    },
    initViewChanging: function () {
      this.optiscrollContentDOM = this.$el.querySelector('.optiscroll-content')
      this.eventListDOM = this.$el.querySelector('.event-list')
    },
    switchScrollPos: function () {
      if (this.isListView) {
        let thumbViewScrollPercentage = (this.optiscrollContentDOM.scrollTop / this.eventListDOM.clientHeight) * 100
        this.$nextTick(function () {
          let switchedScrollPos = (thumbViewScrollPercentage / 100) * this.eventListDOM.clientHeight
          this.listViewOffset = (this.scrollAreaDOM.clientHeight / 2) - this.liveEventDOM.clientHeight
          let listViewScrollPos = Math.round(switchedScrollPos - this.listViewOffset)
          this.optiscrollInstance.scrollTo(false, listViewScrollPos, 0)
        })
      } else {
        let listViewScrollPos = this.optiscrollContentDOM.scrollTop + this.listViewOffset
        let listViewScrollPercentage = (listViewScrollPos / this.eventListDOM.clientHeight) * 100
        this.$nextTick(function () {
          let thumbViewScrollPos = Math.round((listViewScrollPercentage / 100) * this.eventListDOM.clientHeight)
          this.optiscrollInstance.scrollTo(false, thumbViewScrollPos, 0)
        })
      }
    },
    initLazyLoad: function () {
      this.scrollAreaDOM.addEventListener('scrollstop', this.scrollStopHandler)
    },
    scrollStopHandler: function (e) {
      let eventsScrolledBy = Math.ceil(e.detail.scrollTop / this.liveEventDOM.clientHeight)
      this.currentEventIndex = eventsScrolledBy + 1
      // console.log('this.currentEventIndex', this.currentEventIndex)
      this.updateEpgOnScroll()
    },
    updateEpgOnScroll: function () {
      let beforeCurrent = this.currentEventIndex - this.difference
      let afterCurrent = this.currentEventIndex + this.difference + this.totalDaysInEPG
      let epgLength = this.epgWithDays.length

      for (let i = 1; i < epgLength; i++) {
        if (i > beforeCurrent && i < afterCurrent) {
          this.$set(this.epgWithDays[i], 'itemVisible', true)
        } else {
          this.$set(this.epgWithDays[i], 'itemVisible', false)
        }
      }
    },
    initLiveMarker: function () {
      this.epgWrap = document.querySelector('.epg-wrap')
      this.liveMarker = document.querySelector('.live-marker')
      this.liveMarkerTop = document.querySelector('.marker-top')
      this.liveMarkerBottom = document.querySelector('.marker-bottom')
      this.scrollAreaDOM.addEventListener('sizechange', this.positionMarker)
    },
    initCalendarDays: function () {
      this.dateElemsDOM = this.$el.querySelectorAll('.date')
      this.dateElemsDOMlength = this.dateElemsDOM.length - 1
      this.scrollAreaDOM.addEventListener('scroll', this.calendarDaysScrollHandler)
    },
    calendarDaysScrollHandler: function () {
      for (let i = this.dateElemsDOMlength; i > 0; i--) {
        let dateElem = this.dateElemsDOM[i]
        if (dateElem.getBoundingClientRect().top <= window.innerHeight / 2) {
          this.calendarDayOnScroll = dateElem.className.split('--')[1]
          break
        }
      }
      this.positionMarker()
    },
    positionMarker: function () {
      this.epgWrapTop = this.epgWrap.getBoundingClientRect().top
      this.epgWrapBottom = this.epgWrap.getBoundingClientRect().bottom
      this.liveMarkerPosition = this.liveMarker.getBoundingClientRect().top + 18

      if (this.liveMarkerPosition < this.epgWrapTop) {
        this.markerPosition = 'top'
      } else if (this.liveMarkerPosition > this.epgWrapBottom) {
        this.markerPosition = 'bottom'
      } else {
        this.markerPosition = 'center'
      }
    },
    reloadMarker: function () {
      this.liveMarker = document.querySelector('.live-marker')
      this.markerPosition = ''
      this.centerCustomEvent('.live-event')
    },
    showEvents: function () {
      this.changing = false
    }
  },
  created () {
    this.UPDATE_IS_LOADING(true)
  },
  mounted: function () {
    if (this.epgEventListExists) {
      this.createEpgWithDays()
      this.$nextTick(function () {
        this.initOptiscroll()
        this.initCenterLiveEvent()
        this.initViewChanging()
        this.initLazyLoad()
        this.initLiveMarker()
        this.initCalendarDays()
        // console.log('EventList initOptiscroll() on mounted...')
      })
    }
  },
  watch: {
    epgEventListExists: function (newValue) {
      if (newValue) {
        this.createEpgWithDays()
        this.$nextTick(function () {
          this.initOptiscroll()
          this.initViewChanging()
          this.initLazyLoad()
          this.initLiveMarker()
          this.initCalendarDays()
          // console.log('EventList initOptiscroll() on watch...')
        })
      }
    },
    channelChanged: function () {
      var self = this
      this.changing = true
      setTimeout(function () {
        self.createEpgWithDays()
        if (self.liveMarkerTop && self.liveMarkerBottom) {
          self.liveMarkerTop.classList.add('hidden')
          self.liveMarkerBottom.classList.add('hidden')
        }
      }, 200)
      // this.changing = true
      // this.$nextTick(function () {
      //   this.initCenterLiveEvent()
      // })
    },
    isListView: function () {
      this.switchScrollPos()
      // console.log('View changed...')
    },
    epgEventListLength: function () {
      setTimeout(() => {
        this.$nextTick(function () {
          this.initCenterLiveEvent()
          // this.changing = false
          this.dateElemsDOM = this.$el.querySelectorAll('.date')
          this.dateElemsDOMlength = this.dateElemsDOM.length - 1
          this.liveMarker = document.querySelector('.live-marker')
          this.markerPosition = ''
        })
      }, 500)
    },
    calendarDayOnScroll: function (value) {
      this.UPDATE_CALENDAR_DAY(value)
    },
    calendarScrollToSelector: function (value) {
      if (value === '.event-live') {
        value = '.live-event'
      }
      this.centerCustomEvent(value)
    },
    markerPosition: function (value) {
      if (value === 'top') {
        this.liveMarkerTop.classList.add('visible')
        this.liveMarker.classList.remove('visible')
        this.liveMarkerBottom.classList.remove('visible')
      } else if (value === 'bottom') {
        this.liveMarkerTop.classList.remove('visible')
        this.liveMarker.classList.remove('visible')
        this.liveMarkerBottom.classList.add('visible')
      } else {
        this.liveMarkerTop.classList.remove('visible')
        this.liveMarker.classList.add('visible')
        this.liveMarkerBottom.classList.remove('visible')
      }
    }
  },
  beforeDestroy: function () {
    if (this.epgEventListExists) {
      this.scrollAreaDOM.removeEventListener('scroll', this.calendarDaysScrollHandler)
      this.scrollAreaDOM.removeEventListener('scrollstop', this.scrollStopHandler)
      this.scrollAreaDOM.removeEventListener('sizechange', this.positionMarker)
      this.optiscrollInstance.destroy()
      // console.log('EventList destroy optiscroll...')
    }
  }
}
</script>

<style scoped lang="scss">
    @import 'uc/_variables';

    .event-list-wrapper {
        width: 73%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        padding-left: 20px;
        padding-right: 24px;

        &:before {
            content: '';
            width: 50px;
            height: 100%;
            background: #cfcfcf;
            background: linear-gradient(90deg,#d7d7d7,hsla(0,0%,89%,.91) 9%,hsla(0,0%,100%,0));
            position: absolute;
            top: 0;
            left: 0;
        }
    }

    .inner-wrapper {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        visibility: visible;
        opacity: 1;
        transition: opacity 0.3s ease, visibility 0.3s ease;
        padding-right: 24px;
        &.changing {
            visibility: hidden;
            opacity: 0;
        }
    }

    #events-scroll {
        height: 100%;
    }

    .event-list {
        visibility: visible;
        padding: 20px 20px 0 36px;
        transform: scale3d(1, 1, 1);
        backface-visibility: hidden;
        perspective: 1000px;
    }

    .ie .event-list {
        backface-visibility: visible;
    }

    // Marker
    .marker {
        width: 44px;
        height: 34px;
        position: absolute;
        background: url(~assets/images/icons/marker.png) 0 0 no-repeat;
        background-size: 100%;
        font-size: 13px;
        color: #fff;
        cursor: pointer;
        line-height: 32px;
        padding-left: 4px;
        z-index: 1;
        left: 14px;
        visibility: hidden;
            &.visible {
                visibility: visible;
            }
            &.hidden {
              visibility: hidden !important;
            }
    }
    .marker-top {
        transform: rotateZ(-90deg);
        top: 5px;
    }
    .marker-bottom {
        transform: rotateZ(90deg);
        bottom: 5px;
    }

    @media only screen and (min-width: $breakpoint2) {
        .event-list {
            padding-left: 56px;
        }
        .marker {
            left: 38px;
        }
    }

    @media only screen and (min-width: $breakpoint3) {
      .event-list {
        padding-left: 80px;
      }
      .marker {
        left: 58px;
      }
    }

    // Loader
    $green: #46FF46;
    $blue: #2D1EFF;
    $pink: #FA55FA;
    $yellow: #FFEB50;
    $white: #eee;

    .loader {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100px;
        height: 100px;
        margin: auto;
        opacity: 0;
        transition: opacity 0.3s ease;
            &.show-loader {
                opacity: 1;
            }
    }

    .loader-fallback {
        display: none;
        text-align: center;
        line-height: 100px;
        text-transform: uppercase;
        font-size: 16px;
        color: #323e43;
    }
    .ie {
        .loader-fallback {
            display: block;
        }
    }

    .circular {
        animation: rotate 2s linear infinite;
        height: 100%;
        transform-origin: center center;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
    }

    .path {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
        animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
        stroke-linecap: round;
    }

    @keyframes rotate {
        100% {
             transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 200;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -35px;
        }
        100% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -124px;
        }
    }

    @keyframes color {
        100%,
        0% {
            stroke: $pink;
        }
        40% {
            stroke: $blue;
        }
        66% {
            stroke: $green;
        }
        80%,
        90% {
            stroke: $yellow;
        }
    }

    @keyframes show-page-loader {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    @keyframes hide-page-loader {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

    @media screen and (min-width: $breakpoint3) {
        .loader-fallback {
            font-size: 20px;
        }
    }

</style>

<style lang="scss">

    // Edge scrollbar fix
    body.edge .event-list-wrapper .optiscroll-h {
      display: none;
    }

</style>



// WEBPACK FOOTER //
// src/containers/sections/Guide/EventList.vue